// Libraries
import React, { Component } from 'react';
import ImageUploader from '../form-fields/wr-images-upload';

import { translate } from '../../globals/translations';

class ImageUpload extends Component {
    constructor(props) {
        super(props);

        this.state = {
            images: [],
            session_key: 'road_photo',
        };

        this.onImageSelect = this.onImageSelect.bind(this);
    }

    componentDidMount() {
        this.restrictAcceptedFileTypes();
    }

    onImageSelect(images) {
        this.setState(
            {
                images,
            },
            () => {
                this.props.setImages(this.state.images);
                this.fixImagePath();
            }
        );
    }

    /**
     * Check if we have images.
     *
     * Using the lenght of the this.state.images, return true if we have more than 1,
     * false if less than or equal to 0.
     *
     * @returns boolean
     */
    haveImages() {
        if (this.props.images.length <= 0) {
            return false;
        }

        return true;
    }

    /**
     * The JakeHartnell/react-images-upload package does not restrict file types properly.
     *
     * This function fixes that problem and ran on componentDidMount. This is not a
     * full fix (kinda shitty) but will do for the current version (2020 campaign).
     * Some browsers still let users select different file types.
     *
     */
    restrictAcceptedFileTypes() {
        const input_field = document.querySelector('input[type="file"]'); // Safe to do this. We only have 1 file input on step 1.

        input_field.accept = 'image/png, image/jpeg, image/gif';
    }

    /**
     * Clear all of the validation errors that's related to photo upload.
     *
     * This function is called on componentDidUpdate and if this.state.images.lenght is
     * greater than 0. This means that the user actually selected a valid image
     * so it's safe to hide all validation errors.
     */
    clearValidationErrors() {
        if (!this.haveImages()) {
            return; // Don't do anything we have no images.
        }

        const validation_errors = document.querySelectorAll('.errorMessage');

        // Using for loop here to support IE 11 :(
        for (let i = 0; i < validation_errors.length; i++) {
            const validation_error = validation_errors[i];

            validation_error.innerHTML = '';
        }
    }

    /**
     * Fix french characters in inline data image src for preview.
     */
    fixImagePath() {
        const images = document.querySelectorAll('.uploadPicture');

        if (images && images.length) {
            images.forEach((node) => {
                node.src = node.src.replace(/(name=.+;)/, '');
            });
        }
    }

    render() {
        let labelText = `${translate('image_upload_label')} ${translate(
            'optional'
        )}`;
        let helperText = translate('image_max_format');
        let buttonText = translate('image_upload');
        let className =
            this.props.images.length >= this.props.maxImagesLength
                ? 'max-images'
                : '';

        return (
            <ImageUploader
                className={className}
                buttonText={buttonText}
                imgExtension={['.jpg', '.png', '.jpeg', 'gif']}
                labelText={labelText}
                helperText={helperText}
                helperClass={'form-helper-text'}
                helperStyles={{ marginTop: '0.8rem' }}
                maxFileSize={20242880}
                name="photo"
                onChange={this.onImageSelect}
                singleImage={false}
                withIcon={true}
                withPreview={true}
            />
        );
    }
}

export default ImageUpload;
